import type { Root } from 'mdast';
import type { VFile } from 'vfile';
import { visit } from 'unist-util-visit';

import { WP_PLAYLIST_MDX_DIRECTIVE_NAME } from './wpPlaylistMdxDirectiveConstants';

export const wpPlaylistMdxDirectiveRemarkPlugin =
  () =>
  (tree: Root, file: VFile): void => {
    visit(tree, function (node) {
      if (node.type === 'leafDirective') {
        if (node.name !== WP_PLAYLIST_MDX_DIRECTIVE_NAME) {
          return;
        }

        // eslint-disable-next-line no-param-reassign
        const data = node.data ?? (node.data = {});
        const attributes = node.attributes ?? {};

        const url = attributes.url;
        if (!url) {
          file.fail(
            `Unexpected missing \`url\` on \`${WP_PLAYLIST_MDX_DIRECTIVE_NAME}\` directive.`,
            node,
          );
        }

        data.hName = 'iframe';
        data.hProperties = {
          src: url,
          title: 'Playlist',
          style:
            'border: none; border-radius: 10px; background: transparent; display: block; margin:0 auto; width: 100%; height: 72vh;',
        };
      }
    });
  };
